module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/cohort-iv-mentors.json
// module id = 672
// module chunks = 129652598680072